import baseService from "../services/BaseService";

export const addContact = async (values) =>
  baseService.post("contacts", values);
